import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
    ChevronDown,
    ChevronRight,
} from "lucide-react";

import { ImagePath } from "../../assests";
import { NavItem } from "../../navigation/allNav";
import { getNav } from "../../navigation";

interface SidebarProps {
    isOpen: boolean;
    toggleSidebar: () => void;
}

const AdminSidebar: React.FC<SidebarProps> = ({
    isOpen,
    toggleSidebar,
}) => {
    const location = useLocation();

    const [navItems, setNavItems] = useState<NavItem[]>([]);
    const [openDropdowns, setOpenDropdowns] = useState<number[]>([]);

    useEffect(() => {
        setNavItems(getNav("admin"));
        setOpenDropdowns([]);
    }, []);

    const toggleDropdown = (id: number) => {
        setOpenDropdowns((prev) =>
            prev.includes(id)
                ? prev.filter((item) => item !== id)
                : [...prev, id]
        );
    };

    return (
        <>
            {/* Overlay */}
            {isOpen && (
                <div
                    className="fixed inset-0 z-20 md:hidden"
                    onClick={toggleSidebar}
                />
            )}

            <aside
                className={`
                  fixed top-0 left-0 h-screen overflow-hidden z-50
        w-[250px]
        bg-logoHeading
        text-white
        transform transition-transform duration-300
        ${isOpen ? "translate-x-0" : "-translate-x-full"}
        md:translate-x-0
                `}
            >
                {/* Logo */}
                <div className="h-[70px] flex items-center px-6">
                    <img
                        src={ImagePath.Logo}
                        alt="logo"
                        className="h-8 w-auto object-contain"
                    />
                </div>

                {/* Menu */}
                <div className="p-4 space-y-3 overflow-y-auto h-[calc(100vh-70px)] no-scrollbar">
                    {navItems.map((item) => {
                        // if (item.type === "separator") {
                        //     return (
                        //         <div
                        //             key={item.id}
                        //             className="border-t border-gray-300"
                        //         />
                        //     );
                        // }

                        const isParentActive =
                            item.title === "Dashboard"
                                ? location.pathname === "/admin" ||
                                location.pathname === "/admin/admindashboard"
                                : item.path &&
                                location.pathname.startsWith(item.path);

                        const isDropdownOpen =
                            openDropdowns.includes(item.id);

                        return (
                            <div key={item.id}>
                                {/* Parent */}
                                <div
                                    onClick={() => {
                                        if (item.children) {
                                            toggleDropdown(item.id);
                                        }
                                    }}
                                    className={`
                                        flex items-center justify-between
                                        px-2 py-2 rounded-md text-base cursor-pointer transition-all
                                        ${isParentActive
                                            ? "bg-white text-logoHeading"
                                            : "text-logoHeading hover:bg-[#6DBE45] text-white "
                                        }
                                    `}
                                >
                                    <Link
                                        to={item.path || "#"}
                                        className="flex items-center gap-3 flex-1"
                                    >
                                        <span className="w-4 h-4 flex items-center justify-center">
                                            {item.icon}
                                        </span>

                                        <span>{item.title}</span>
                                    </Link>

                                    {item.children && (
                                        <span>
                                            {isDropdownOpen ? (
                                                <ChevronDown size={16} />
                                            ) : (
                                                <ChevronRight size={16} />
                                            )}
                                        </span>
                                    )}
                                </div>

                                {/* Dropdown Children */}
                                {item.children && isDropdownOpen && (
                                    <div className="mt-2 space-y-2">
                                        {item.children.map((child) => {
                                            const isChildActive =
                                                child.path &&
                                                location.pathname.startsWith(
                                                    child.path
                                                );

                                            return (
                                                <Link
                                                    key={child.id}
                                                    to={child.path!}
                                                    onClick={() =>
                                                        window.innerWidth < 768 &&
                                                        toggleSidebar()
                                                    }
                                                    className={`
                                                        flex items-center gap-3
                                                        px-4 py-2 rounded-md text-sm transition-all
                                                        ${isChildActive
                                                            ? "bg-white text-logoHeading"
                                                            : "text-white hover:bg-[#6DBE45] hover:text-white"
                                                        }
                                                    `}
                                                >
                                                    <span className="w-4 h-4 flex items-center justify-center">
                                                        {child.icon}
                                                    </span>

                                                    <span>{child.title}</span>
                                                </Link>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </aside>
        </>
    );
};

export default AdminSidebar;